import { withInstall } from '@xzx-design/utils'
import _DateSelect from './src/date-select'

export const DateSelect = withInstall(_DateSelect)
export default DateSelect

export * from './src/date-select'
